import CommonPlugin from './common-plugin'

const Plugins = {
  install: function(Vue) {
    Vue.use(CommonPlugin)
  }
}
export default Plugins
